/* eslint-disable react/no-unknown-property */
import React, { useState, useContext } from "react";
import NextRouter from "next/router";
import { GlobalContext } from "../components/context/GlobalContext";
import PropTypes from "prop-types";
// Components
import Layout from "../components/common/Layout";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  Divider,
  Button,
} from "@mui/material";
import CareerBody from "../components/career/CareerBody";
import CareerGrid from "../components/career/CareerGrid";
import { makeStyles } from "@mui/styles";
import { OUR_CAREER_ARR } from "utils/constants";
import { IconMaker } from "components/common/IconMaker";

const useStyles = makeStyles((theme) => ({
  pageLayout: {
    backgroundColor: "rgba(220, 241, 236, 0.5)",
    height: 400,
    [theme.breakpoints.down("lg")]: {
      height: 320,
    },
  },
  pageWrapper: {
    backgroundColor: "#ffffff",
    backgroundImage: `
        url("data:image/svg+xml,%3Csvg%20width%3D%22388%22%20height%3D%22416%22%20viewBox%3D%220%200%20388%20416%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Ccircle%20cx%3D%22-19.1217%22%20cy%3D%22218.882%22%20r%3D%22156%22%20transform%3D%22rotate(142.191%20-19.1217%20218.882)%22%20fill%3D%22%23c1e2d5%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M124.53%20161.565C125.238%20161.565%20125.812%20160.991%20125.812%20160.283C125.812%20159.575%20125.238%20159.001%20124.53%20159.001C123.822%20159.001%20123.248%20159.575%20123.248%20160.283C123.248%20160.991%20123.822%20161.565%20124.53%20161.565ZM115.557%20160.283C115.557%20160.991%20114.983%20161.565%20114.275%20161.565C113.568%20161.565%20112.994%20160.991%20112.994%20160.283C112.994%20159.575%20113.568%20159.001%20114.275%20159.001C114.983%20159.001%20115.557%20159.575%20115.557%20160.283ZM114.275%20171.819C114.983%20171.819%20115.557%20171.245%20115.557%20170.538C115.557%20169.83%20114.983%20169.256%20114.275%20169.256C113.567%20169.256%20112.994%20169.83%20112.994%20170.538C112.994%20171.245%20113.567%20171.819%20114.275%20171.819ZM124.53%20171.819C125.238%20171.819%20125.812%20171.246%20125.812%20170.538C125.812%20169.83%20125.238%20169.256%20124.53%20169.256C123.822%20169.256%20123.248%20169.83%20123.248%20170.538C123.248%20171.246%20123.822%20171.819%20124.53%20171.819ZM136.066%20170.538C136.066%20171.246%20135.492%20171.819%20134.784%20171.819C134.076%20171.819%20133.502%20171.246%20133.502%20170.538C133.502%20169.83%20134.076%20169.256%20134.784%20169.256C135.492%20169.256%20136.066%20169.83%20136.066%20170.538ZM145.039%20171.819C145.747%20171.819%20146.321%20171.246%20146.321%20170.538C146.321%20169.83%20145.747%20169.256%20145.039%20169.256C144.331%20169.256%20143.757%20169.83%20143.757%20170.538C143.757%20171.246%20144.331%20171.819%20145.039%20171.819ZM156.575%20170.538C156.575%20171.246%20156.001%20171.819%20155.293%20171.819C154.585%20171.819%20154.011%20171.246%20154.011%20170.538C154.011%20169.83%20154.585%20169.256%20155.293%20169.256C156.001%20169.256%20156.575%20169.83%20156.575%20170.538ZM165.548%20171.819C166.256%20171.819%20166.83%20171.246%20166.83%20170.538C166.83%20169.83%20166.256%20169.256%20165.548%20169.256C164.84%20169.256%20164.266%20169.83%20164.266%20170.538C164.266%20171.246%20164.84%20171.819%20165.548%20171.819ZM136.066%20160.283C136.066%20160.991%20135.492%20161.565%20134.784%20161.565C134.076%20161.565%20133.503%20160.991%20133.503%20160.283C133.503%20159.575%20134.076%20159.001%20134.784%20159.001C135.492%20159.001%20136.066%20159.575%20136.066%20160.283ZM145.039%20161.565C145.747%20161.565%20146.321%20160.991%20146.321%20160.283C146.321%20159.575%20145.747%20159.001%20145.039%20159.001C144.331%20159.001%20143.757%20159.575%20143.757%20160.283C143.757%20160.991%20144.331%20161.565%20145.039%20161.565ZM156.575%20160.283C156.575%20160.991%20156.001%20161.565%20155.293%20161.565C154.585%20161.565%20154.012%20160.991%20154.012%20160.283C154.012%20159.575%20154.585%20159.001%20155.293%20159.001C156.001%20159.001%20156.575%20159.575%20156.575%20160.283ZM165.548%20161.565C166.256%20161.565%20166.83%20160.991%20166.83%20160.283C166.83%20159.575%20166.256%20159.001%20165.548%20159.001C164.84%20159.001%20164.266%20159.575%20164.266%20160.283C164.266%20160.991%20164.84%20161.565%20165.548%20161.565ZM124.53%20182.074C125.238%20182.074%20125.812%20181.5%20125.812%20180.792C125.812%20180.084%20125.238%20179.51%20124.53%20179.51C123.822%20179.51%20123.248%20180.084%20123.248%20180.792C123.248%20181.5%20123.822%20182.074%20124.53%20182.074ZM115.557%20180.792C115.557%20181.5%20114.983%20182.074%20114.275%20182.074C113.567%20182.074%20112.994%20181.5%20112.994%20180.792C112.994%20180.084%20113.567%20179.51%20114.275%20179.51C114.983%20179.51%20115.557%20180.084%20115.557%20180.792ZM124.53%20192.328C125.238%20192.328%20125.812%20191.754%20125.812%20191.046C125.812%20190.338%20125.238%20189.764%20124.53%20189.764C123.822%20189.764%20123.248%20190.338%20123.248%20191.046C123.248%20191.754%20123.822%20192.328%20124.53%20192.328ZM114.275%20192.328C114.983%20192.328%20115.557%20191.754%20115.557%20191.046C115.557%20190.338%20114.983%20189.764%20114.275%20189.764C113.567%20189.764%20112.994%20190.338%20112.994%20191.046C112.994%20191.754%20113.567%20192.328%20114.275%20192.328ZM136.066%20191.046C136.066%20191.754%20135.492%20192.328%20134.784%20192.328C134.076%20192.328%20133.502%20191.754%20133.502%20191.046C133.502%20190.338%20134.076%20189.764%20134.784%20189.764C135.492%20189.764%20136.066%20190.338%20136.066%20191.046ZM145.039%20192.328C145.747%20192.328%20146.321%20191.754%20146.321%20191.046C146.321%20190.338%20145.747%20189.764%20145.039%20189.764C144.331%20189.764%20143.757%20190.338%20143.757%20191.046C143.757%20191.754%20144.331%20192.328%20145.039%20192.328ZM156.575%20191.046C156.575%20191.754%20156.001%20192.328%20155.293%20192.328C154.585%20192.328%20154.011%20191.754%20154.011%20191.046C154.011%20190.338%20154.585%20189.764%20155.293%20189.764C156.001%20189.764%20156.575%20190.338%20156.575%20191.046ZM165.548%20192.328C166.256%20192.328%20166.83%20191.754%20166.83%20191.046C166.83%20190.338%20166.256%20189.764%20165.548%20189.764C164.84%20189.764%20164.266%20190.338%20164.266%20191.046C164.266%20191.754%20164.84%20192.328%20165.548%20192.328ZM136.066%20180.792C136.066%20181.5%20135.492%20182.074%20134.784%20182.074C134.076%20182.074%20133.503%20181.5%20133.503%20180.792C133.503%20180.084%20134.076%20179.51%20134.784%20179.51C135.492%20179.51%20136.066%20180.084%20136.066%20180.792ZM145.039%20182.074C145.747%20182.074%20146.321%20181.5%20146.321%20180.792C146.321%20180.084%20145.747%20179.51%20145.039%20179.51C144.331%20179.51%20143.757%20180.084%20143.757%20180.792C143.757%20181.5%20144.331%20182.074%20145.039%20182.074ZM156.575%20180.792C156.575%20181.5%20156.001%20182.074%20155.293%20182.074C154.585%20182.074%20154.012%20181.5%20154.012%20180.792C154.012%20180.084%20154.585%20179.51%20155.293%20179.51C156.001%20179.51%20156.575%20180.084%20156.575%20180.792ZM165.548%20182.074C166.256%20182.074%20166.83%20181.5%20166.83%20180.792C166.83%20180.084%20166.256%20179.51%20165.548%20179.51C164.84%20179.51%20164.266%20180.084%20164.266%20180.792C164.266%20181.5%20164.84%20182.074%20165.548%20182.074Z%22%20fill%3D%22%23001B11%22%2F%3E%3Ccircle%20cx%3D%22330.497%22%20cy%3D%22425.5%22%20r%3D%2257.5%22%20fill%3D%22%23f2bdc4%22%2F%3E%3Ccircle%20cx%3D%22297.51%22%20cy%3D%22113.51%22%20r%3D%2231.6399%22%20transform%3D%22rotate(109.873%20297.51%20113.51)%22%20fill%3D%22%23fbe095%22%2F%3E%3C%2Fsvg%3E"),
        url("data:image/svg+xml,%3Csvg%20width%3D%22390%22%20height%3D%22316%22%20viewBox%3D%220%200%20390%20316%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0)%22%3E%3Cpath%20d%3D%22M217.497%20115C249.253%20115%20274.997%2089.2564%20274.997%2057.5C274.997%2025.7436%20249.253%200%20217.497%200C185.741%200%20159.997%2025.7436%20159.997%2057.5C159.997%2089.2564%20185.741%20115%20217.497%20115Z%22%20fill%3D%22%23CDE8DD%22%2F%3E%3Cpath%20d%3D%22M212.628%20352.793C288.583%20393.46%20383.123%20364.852%20423.79%20288.897C464.456%20212.942%20435.849%20118.402%20359.894%2077.7355C283.939%2037.0691%20189.398%2065.6763%20148.732%20141.631C108.066%20217.586%20136.673%20312.127%20212.628%20352.793Z%22%20fill%3D%22%23FBE095%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M117.534%20140.564C118.242%20140.564%20118.815%20139.99%20118.815%20139.282C118.815%20138.574%20118.242%20138%20117.534%20138C116.826%20138%20116.252%20138.574%20116.252%20139.282C116.252%20139.99%20116.826%20140.564%20117.534%20140.564ZM108.561%20139.282C108.561%20139.99%20107.987%20140.564%20107.279%20140.564C106.571%20140.564%20105.997%20139.99%20105.997%20139.282C105.997%20138.574%20106.571%20138%20107.279%20138C107.987%20138%20108.561%20138.574%20108.561%20139.282ZM107.279%20150.818C107.987%20150.818%20108.561%20150.244%20108.561%20149.537C108.561%20148.829%20107.987%20148.255%20107.279%20148.255C106.571%20148.255%20105.997%20148.829%20105.997%20149.537C105.997%20150.244%20106.571%20150.818%20107.279%20150.818ZM117.534%20150.819C118.242%20150.819%20118.815%20150.245%20118.815%20149.537C118.815%20148.829%20118.242%20148.255%20117.534%20148.255C116.826%20148.255%20116.252%20148.829%20116.252%20149.537C116.252%20150.245%20116.826%20150.819%20117.534%20150.819ZM129.07%20149.537C129.07%20150.245%20128.496%20150.819%20127.788%20150.819C127.08%20150.819%20126.506%20150.245%20126.506%20149.537C126.506%20148.829%20127.08%20148.255%20127.788%20148.255C128.496%20148.255%20129.07%20148.829%20129.07%20149.537ZM138.043%20150.819C138.751%20150.819%20139.324%20150.245%20139.324%20149.537C139.324%20148.829%20138.751%20148.255%20138.043%20148.255C137.335%20148.255%20136.761%20148.829%20136.761%20149.537C136.761%20150.245%20137.335%20150.819%20138.043%20150.819ZM149.579%20149.537C149.579%20150.245%20149.005%20150.819%20148.297%20150.819C147.589%20150.819%20147.015%20150.245%20147.015%20149.537C147.015%20148.829%20147.589%20148.255%20148.297%20148.255C149.005%20148.255%20149.579%20148.829%20149.579%20149.537ZM158.552%20150.819C159.26%20150.819%20159.833%20150.245%20159.833%20149.537C159.833%20148.829%20159.26%20148.255%20158.552%20148.255C157.844%20148.255%20157.27%20148.829%20157.27%20149.537C157.27%20150.245%20157.844%20150.819%20158.552%20150.819ZM129.07%20139.282C129.07%20139.99%20128.496%20140.564%20127.788%20140.564C127.08%20140.564%20126.506%20139.99%20126.506%20139.282C126.506%20138.574%20127.08%20138%20127.788%20138C128.496%20138%20129.07%20138.574%20129.07%20139.282ZM138.043%20140.564C138.751%20140.564%20139.324%20139.99%20139.324%20139.282C139.324%20138.574%20138.751%20138%20138.043%20138C137.335%20138%20136.761%20138.574%20136.761%20139.282C136.761%20139.99%20137.335%20140.564%20138.043%20140.564ZM149.579%20139.282C149.579%20139.99%20149.005%20140.564%20148.297%20140.564C147.589%20140.564%20147.015%20139.99%20147.015%20139.282C147.015%20138.574%20147.589%20138%20148.297%20138C149.005%20138%20149.579%20138.574%20149.579%20139.282ZM158.552%20140.564C159.26%20140.564%20159.833%20139.99%20159.833%20139.282C159.833%20138.574%20159.26%20138%20158.552%20138C157.844%20138%20157.27%20138.574%20157.27%20139.282C157.27%20139.99%20157.844%20140.564%20158.552%20140.564ZM117.534%20161.073C118.242%20161.073%20118.815%20160.499%20118.815%20159.791C118.815%20159.083%20118.242%20158.509%20117.534%20158.509C116.826%20158.509%20116.252%20159.083%20116.252%20159.791C116.252%20160.499%20116.826%20161.073%20117.534%20161.073ZM108.561%20159.791C108.561%20160.499%20107.987%20161.073%20107.279%20161.073C106.571%20161.073%20105.997%20160.499%20105.997%20159.791C105.997%20159.083%20106.571%20158.509%20107.279%20158.509C107.987%20158.509%20108.561%20159.083%20108.561%20159.791ZM117.534%20171.327C118.242%20171.327%20118.815%20170.753%20118.815%20170.045C118.815%20169.337%20118.242%20168.763%20117.534%20168.763C116.826%20168.763%20116.252%20169.337%20116.252%20170.045C116.252%20170.753%20116.826%20171.327%20117.534%20171.327ZM107.279%20171.327C107.987%20171.327%20108.561%20170.753%20108.561%20170.045C108.561%20169.337%20107.987%20168.763%20107.279%20168.763C106.571%20168.763%20105.997%20169.337%20105.997%20170.045C105.997%20170.753%20106.571%20171.327%20107.279%20171.327ZM129.07%20170.045C129.07%20170.753%20128.496%20171.327%20127.788%20171.327C127.08%20171.327%20126.506%20170.753%20126.506%20170.045C126.506%20169.337%20127.08%20168.763%20127.788%20168.763C128.496%20168.763%20129.07%20169.337%20129.07%20170.045ZM138.043%20171.327C138.751%20171.327%20139.324%20170.753%20139.324%20170.045C139.324%20169.337%20138.751%20168.763%20138.043%20168.763C137.335%20168.763%20136.761%20169.337%20136.761%20170.045C136.761%20170.753%20137.335%20171.327%20138.043%20171.327ZM149.579%20170.045C149.579%20170.753%20149.005%20171.327%20148.297%20171.327C147.589%20171.327%20147.015%20170.753%20147.015%20170.045C147.015%20169.337%20147.589%20168.763%20148.297%20168.763C149.005%20168.763%20149.579%20169.337%20149.579%20170.045ZM158.552%20171.327C159.26%20171.327%20159.833%20170.753%20159.833%20170.045C159.833%20169.337%20159.26%20168.763%20158.552%20168.763C157.844%20168.763%20157.27%20169.337%20157.27%20170.045C157.27%20170.753%20157.844%20171.327%20158.552%20171.327ZM129.07%20159.791C129.07%20160.499%20128.496%20161.073%20127.788%20161.073C127.08%20161.073%20126.506%20160.499%20126.506%20159.791C126.506%20159.083%20127.08%20158.509%20127.788%20158.509C128.496%20158.509%20129.07%20159.083%20129.07%20159.791ZM138.043%20161.073C138.751%20161.073%20139.324%20160.499%20139.324%20159.791C139.324%20159.083%20138.751%20158.509%20138.043%20158.509C137.335%20158.509%20136.761%20159.083%20136.761%20159.791C136.761%20160.499%20137.335%20161.073%20138.043%20161.073ZM149.579%20159.791C149.579%20160.499%20149.005%20161.073%20148.297%20161.073C147.589%20161.073%20147.015%20160.499%20147.015%20159.791C147.015%20159.083%20147.589%20158.509%20148.297%20158.509C149.005%20158.509%20149.579%20159.083%20149.579%20159.791ZM158.552%20161.073C159.26%20161.073%20159.833%20160.499%20159.833%20159.791C159.833%20159.083%20159.26%20158.509%20158.552%20158.509C157.844%20158.509%20157.27%20159.083%20157.27%20159.791C157.27%20160.499%20157.844%20161.073%20158.552%20161.073Z%22%20fill%3D%22%23001B11%22%2F%3E%3Cpath%20d%3D%22M11.6029%2047.7544C5.6628%2064.188%2014.1695%2082.3255%2030.6031%2088.2656C47.0367%2094.2057%2065.1742%2085.6991%2071.1143%2069.2655C77.0544%2052.8318%2068.5478%2034.6943%2052.1142%2028.7542C35.6806%2022.8141%2017.5431%2031.3207%2011.6029%2047.7544Z%22%20fill%3D%22%23F2BDC4%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0%22%3E%3Crect%20width%3D%22390%22%20height%3D%22316%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E")
      `,
    margin: "auto",
    backgroundRepeat: "no-repeat",
    height: "100%",
    backgroundPosition: "left, bottom right",

    [theme.breakpoints.down("lg")]: {
      backgroundSize: "128px 201px, 310px 258px",
    },
  },
  careerCard: {
    position: "relative",
    top: 180,
    borderRadius: 8,
    minWidth: 275,
    maxWidth: 384,
    boxShadow: "0px 8px 18px rgba(0, 0, 0, 0.1)",
    "@media (max-width: 960px)": {
      position: "relative",
      top: 40,
      wordWrap: "break-word",
      width: "100vw",
    },
  },
  careerPositionsCard: {
    direction: "row",
    justifyContent: "space-around",
    alignItems: "center",
    flexWrap: "nowrap",
    "@media (max-width: 1148px)": {
      flexWrap: "wrap",
    },
  },
  careerJobCard: {
    borderRadius: 8,
    minWidth: 275,
    maxWidth: 384,
    boxShadow: "0px 8px 18px rgba(0, 0, 0, 0.1)",
  },
  careerCardContent: {
    height: "100%",
    width: "100%",
  },
  careerTitleStyle: {
    fontSize: 24,
    letterSpacing: 0.15,
    fontFamily: "Poppins",
    fontWeight: 500,
    color: "rgba(0, 27, 17, 1)",
    textAlign: "center",
    marginBottom: 5,
    marginTop: 4,
  },
  careerTitleGreen: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 18,
    lineHeight: "150%",
    color: "#2eb790",
  },
  careerRole2Style: {
    fontSize: 17,
    letterSpacing: 0.15,
    fontFamily: "Poppins",
    fontWeight: 500,
    color: "#102A42",
  },
  careerBody2Style: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 34,
    lineHeight: "150%",
    letterSpacing: ".15px",
  },
  buttonProperties: {
    width: 246,
    height: 37,
    borderRadius: 24,
    padding: "8px, 83px",
    background: "#2eb790",
  },
  marginSection: {
    padding: "128px 16px",
    [theme.breakpoints.down("lg")]: {
      padding: "48px 16px",
    },
  },
  marginMobileTitle: {
    marginTop: theme.spacing(8),
  },
  marginSectionBottom: {
    paddingTop: "128px",
    [theme.breakpoints.down("lg")]: {
      paddingTop: "48px",
    },
  },
  marginRow: {
    marginTop: 48,
  },
  marginBottom: {
    marginBottom: 20,
  },
  subtitle: {
    //  marginTop: "20%"
    fontFamily: "Open Sans",
    fontWeight: 400,
    fontSize: 18,
  },
  logosGrid: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    columnGap: "4px",
    alignItems: "center",
    justifyItems: "left",
  },
  logoScale: {
    transition: "transform .2s",
    "&:hover": {
      transform: "scale(1.2)",
    },
  },
}));

const Careers = () => {
  // Set up the useRouter Hook
  const classes = useStyles();
  const [jobCount, setJobCount] = useState(undefined);

  return (
    <Layout isHomePage={false}>
      <section className={classes.pageLayout}>
        <div className={classes.pageWrapper}>
          <Grid
            container
            direction="column"
            justifyContent="space-around"
            alignItems="center"
            style={{ height: "100%" }}
            aria-label="Careers"
          >
            <Grid item className={classes.marginMobileTitle}>
              <Typography variant="h1" align="center">
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "40px", // Adjusted the size to be more balanced
                  }}
                >
                  Join Our Team
                </span>
              </Typography>
              <Typography variant="h1" align="center">
                <span
                  style={{
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    fontSize: "30px", // Same size for consistency
                  }}
                >
                  Explore Career Opportunities at TeammateMe
                </span>
              </Typography>
            </Grid>
            {/* <Grid item>
  <Typography variant="subtitle2" className={classes.subtitle}>
    Come Work with TeammateMe
  </Typography>
</Grid> */}
          </Grid>
        </div>
      </section>
      <section className={classes.marginSection}>
        <Container>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Grid item md={6} className={classes.marginBottom}>
              <CareerBody
                title={"Our Mission"}
                body1={
                  "TeammateMe’s mission is to facilitate team formation, partnerships and collaboration. We give users the ability to accumulate lasting reputation during team projects, where their reputation can help them to form teams and network for coursework, extracircular activities, hobbies and professional work."
                }
              />
              <Grid item>
                <Button
                  onClick={() => NextRouter.push("/blogroll")}
                  variant="contained"
                  color="primary"
                  aria-label="Learn More"
                >
                  Learn More &nbsp;&nbsp;
                  <span role="img" aria-label="emojiBook">
                    📚
                  </span>
                </Button>
              </Grid>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className={classes.careerCard}>
                <CardContent className={classes.careerCardContent}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="space-evenly"
                    alignItems="baseline"
                    paddingRight={4}
                  >
                    <Grid item>
                      <Typography className={classes.careerTitleGreen}>
                        Our Values
                      </Typography>
                    </Grid>
                    <br />
                    <Grid item className={classes.logosGrid}>
                      <IconMaker name="heart" width="48px" height="48px" />
                      <Typography className={classes.careerRole2Style}>
                        Integrity & Trustworthiness
                      </Typography>
                    </Grid>
                    <br />
                    <Grid item className={classes.logosGrid}>
                      <IconMaker name="people" width="48px" height="48px" />
                      <Typography className={classes.careerRole2Style}>
                        Long Term Relationships with users, customers &
                        employees
                      </Typography>
                    </Grid>
                    <br />
                    <Grid item className={classes.logosGrid}>
                      <IconMaker name="suitcase" width="48px" height="48px" />
                      <Typography className={classes.careerRole2Style}>
                        Professionalism & Reliability
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          {/* 2nd row, 2nd section */}
        </Container>
        <br />
        <br />
        <Container>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            className={classes.marginRow}
          >
            <Grid item md={6} className={classes.marginBottom}>
              <CareerBody
                title={"Who Should Work at TeammateMe?"}
                body1={
                  "We are looking for friendly and self-driven individuals that love what they do and strive for continuous improvement. These individuals can work in a fast paced, yet collaborative environment, and work independently outside of our daily meetings. Our team encourages the creation of real value for customers and clients and long-term relationships with customers, employees, and the partners of TeammateMe."
                }
              />
            </Grid>
            {/* 2nd row: Card small */}
            <Grid item md={4}></Grid>
          </Grid>
        </Container>

        <Container className={classes.marginSectionBottom}>
          <Typography className={classes.careerTitleStyle}>
            <b className="becomeTeamMem"> Become a part of the team </b>
          </Typography>
          <br />
          <Divider variant="middle" />
          <br />
          <Grid container className={classes.careerPositionsCard}>
            {OUR_CAREER_ARR.map((x, i) => {
              return <CareerGrid key={i} cardProps={x} />;
            })}
          </Grid>
        </Container>
      </section>
      <p style={{ color: "white" }}>{jobCount}</p>
    </Layout>
  );
};

export default Careers;
